export default {
  OPEN_CHARGE_QUITER_MODAL_DEALER: 'OPEN_CHARGE_QUITER_MODAL_DEALER',
  OPEN_CHARGE_QUITER_MODAL_DEALER_SUCCESS: 'OPEN_CHARGE_QUITER_MODAL_DEALER_SUCCES',
  CLOSE_CHARGE_QUITER_MODAL_DEALER: 'CLOSE_CHARGE_QUITER_MODAL_DEALER',
  GET_VEHICLE_DATA_QUITER: 'GET_VEHICLE_DATA_QUITER',
  GET_VEHICLE_DATA_QUITER_SUCCESS: 'GET_VEHICLE_DATA_QUITER_SUCCESS',
  SEND_VEHICLE_DATA_QUITER: 'SEND_VEHICLE_DATA_QUITER',
  SEND_VEHICLE_DATA_QUITER_SUCCESS: 'SEND_VEHICLE_DATA_QUITER_SUCCESS'
}
